import React, { useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import ForumIcon from '@mui/icons-material/Forum';
import ChatIcon from '@mui/icons-material/Chat';
import CloseIcon from '@mui/icons-material/Close';
import { Rnd } from 'react-rnd';
import UserList from "./SmallUserList";
import ChatWindow from "./Smallwindow";
import ALLThreadWindow from "../Threadlist";

const ChatAppSmall = ({ SetChatBox }) => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [showThreadView, setShowThreadView] = useState(false);
  const [isMinimized, setMinimized] = useState(false);

  const toggleChat = () => { SetChatBox(false); };
  const toggleThreadView = () => { setShowThreadView(!showThreadView); };

  return (
    <Rnd
      className="mui-fixed"
      default={{ x: 120, y: 90, width: 650, height: 550 }}
      dragHandleClassName="window-header"
      cancel=".chat-content-area,input,textarea,button"
      size={isMinimized ? { width: 220, height: 48 } : undefined}
      minWidth={500}
      minHeight={400}
      bounds="window"
      style={{ zIndex: 1290, overflow: 'hidden', borderRadius: '16px', border: '1px solid rgba(148,163,184,0.2)', boxShadow: '0 20px 50px rgba(15,23,42,0.18)' }}
    >
      {/* Draggable Header */}
      <Box 
        className="window-header"
        sx={{ 
          height: '36px', 
          background: 'linear-gradient(90deg, #1d63b3 0%, #154a8a 100%)', // Premium dark gradient for the handle
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'flex-end', 
          padding: '0 10px',
          cursor: 'grab',
          '&:active': { cursor: 'grabbing' }
        }}
      >
        <Box sx={{ display: 'flex', gap: '6px' }}>
          <IconButton 
            size="small" 
            onClick={toggleChat} 
            sx={{ 
              color: 'rgba(255,255,255,0.8)', 
              width: '24px', 
              height: '24px',
              '&:hover': { background: '#F43F5E', color: '#FFFFFF' }
            }}
          >
            <CloseIcon sx={{ fontSize: '16px' }} />
          </IconButton>
        </Box>
      </Box>

      {/* Main Chat Content */}
      {!isMinimized && (
        <Box 
          className="chat-content-area"
          sx={{ 
            height: 'calc(100% - 36px)', 
            display: 'flex', 
            background: '#FFFFFF', 
            width: '100%',
            overflow: 'hidden'
          }}
        >
          {/* Sidebar */}
          <Box 
            sx={{ 
              width: '240px', 
              background: '#FFFFFF', 
              borderRight: '1px solid #F1F5F9', 
              display: 'flex', 
              flexDirection: 'column' 
            }}
          >
            {/* Thread Toggle */}
            <Box 
              onClick={toggleThreadView}
              sx={{ 
                height: '56px',
                px: '16px', 
                display: 'flex', 
                alignItems: 'center', 
                gap: '12px', 
                cursor: 'pointer', 
                color: '#FFFFFF',
                background: '#1d63b3',
                borderRight: '1px solid rgba(255,255,255,0.1)',
                borderRadius: 0, // Explicitly zero out
                transition: 'all 0.2s ease',
                '&:hover': { background: '#154a8a' }
              }}
            >
              {showThreadView ? (
                <>
                  <ChatIcon sx={{ fontSize: '18px' }} />
                  <Typography sx={{ fontSize: '12px', fontWeight: 700 }}>Chat</Typography>
                </>
              ) : (
                <>
                  <ForumIcon sx={{ fontSize: '18px' }} />
                  <Typography sx={{ fontSize: '12px', fontWeight: 700 }}>Threads</Typography>
                </>
              )}
            </Box>

            <Box sx={{ flex: 1, overflowY: 'auto', px: '4px' }}>
              <UserList selectedUser={selectedUser} onSelectUser={setSelectedUser} />
            </Box>
          </Box>

          {/* Chat Window / Thread View */}
          <Box sx={{ flex: 1, minWidth: 0, position: 'relative', background: '#F8FAFC' }}>
            {showThreadView ? (
              <ALLThreadWindow selectedUser={selectedUser} />
            ) : (
              <ChatWindow selectedUser={selectedUser} onClose={() => setSelectedUser(null)} />
            )}
          </Box>
        </Box>
      )}
    </Rnd>
  );
};

export default ChatAppSmall;

